import { motion, Variants } from "framer-motion";

const SessionOne = () => {
  const items = [
    { time: "9:20 AM - 09:32 AM", title: "Sirkin Mota", desc: "Selling Trust in a Market That Doesn’t" },
    { time: "9:32 AM - 09:44 AM", title: "Ahmad XM", desc: "Wealth Begins with Understanding" },
    { time: "9:44 AM - 09:56 AM", title: "Victory Ashaka", desc: "Creativity as a Voice for Justice" },
    { time: "09:56 AM - 10:08 AM", title: "Adesina", desc: "What Are Your Real Assets?" },
    { time: "10:08 AM - 10:28 AM", title: "Networking Break", desc: "" },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.5, 
        ease: "easeOut"
      } 
    },
  };

  return (
    <motion.div 
      className="mb-[5rem] relative px-4 md:px-0" 
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {/* Floating Speaker Badge */}
      <div className="absolute -right-2 md:-right-8 -top-10 z-20 w-24 md:w-40 pointer-events-none">
        <motion.img 
          src="/images/Speakers/speaker-badge-1.svg" 
          alt="Speaker Session I" 
          className="w-full h-full drop-shadow-xl"
          whileHover={{ rotate: 5 }} 
        />
      </div>

      <div className="space-y-[-0.8rem] md:space-y-[-1.2rem]">
        {items.map((item, index) => {
          const isBreak = item.title === "Networking Break";

          return (
            <motion.div 
              key={index} 
              variants={itemVariants}
              whileHover={{ y: -5, scale: 1.01, zIndex: 10 }}
              className={`flex flex-col md:flex-row py-6 px-5 lg:p-[3.125rem] rounded-[1.5rem] md:rounded-[1.9rem] border border-dashed border-[#EA1D2C]/20 transition-all relative ${
                isBreak ? 'bg-[#FFF5F5]' : 'bg-white'
              }`}
            >
              <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 w-full">
                
                {/* TIME COLUMN*/}
                <div className="text-[#EA1D2C] font-normal font-glancyr text-lg md:text-[1.8rem] lg:text-[2rem] min-w-fit md:min-w-[180px] lg:min-w-[220px] md:border-r border-dashed border-[#EA1D2C]/30 md:pr-8 lg:pr-[5rem] flex items-center">
                  <span className="whitespace-pre-line leading-tight">
                    {item.time.split(/[-–—]/)[0].trim()}
                    {"\n- " + item.time.split(/[-–—]/)[1].trim()}
                  </span>
                </div>

                {/* TEXT CONTENT COLUMN */}
                <div className="flex-1 w-full">
                  <h4 className="text-lg md:text-[2rem] font-normal text-[#000000] leading-tight">
                    {item.title}
                  </h4>
                  {item.desc && (
                    <p className="text-[#444444] font-normal mt-1 md:mt-2 text-[1.1rem] opacity-70 leading-relaxed max-w-[25rem]">
                      {item.desc}
                    </p>
                  )}
                </div>

                {/* Networking Illustration */}
                {isBreak && (
                  <div className="absolute right-4 bottom-4 hidden lg:block w-28">
                    <img src="images/Speakers/networking.svg" alt="Networking" className="opacity-90" />
                  </div>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default SessionOne;